import AIFieldMappingDto from "../../classes/dtos/pathaimodule/AIFieldMappingDto";
import DataTableFieldMappingDto from "../../classes/dtos/pathdatatablemodule/DataTableFieldMappingDto";
import MetaApiFieldMappingDto from "../../classes/dtos/pathmetaapimodule/MetaApiFieldMappingDto";
import ReportingFieldMappingDto from "../../classes/dtos/pathreportingmodule/ReportingFieldMappingDto";
import SynchroFieldMappingDto from "../../classes/dtos/pathsynchromodule/SynchroFieldMappingDto";
import TransformationCapabilitiesDto from "../../classes/dtos/transformationmodule/TransformationCapabilitiesDto";
import TransformationOptionsDto from "../../classes/dtos/transformationmodule/TransformationOptionsDto";

export const TransformationLogic = {
    GetOptionsDetails: function (row: SynchroFieldMappingDto, transformationsCapabilities: TransformationCapabilitiesDto[]): TransformationOptionsDto | null {

        if (row.TransformationType === null) {
            return null;
        }

        return transformationsCapabilities.find((e) => e.LogicId === row.TransformationType && e.TransformationCapabilitiesType === "TransformationOptions") as TransformationOptionsDto ?? null;
    },

    GetOptionsDetailsForReporting: function (row: ReportingFieldMappingDto, transformationsCapabilities: TransformationCapabilitiesDto[]): TransformationOptionsDto | null {

        if (row.TransformationType === null) {
            return null;
        }

        return transformationsCapabilities.find((e) => e.LogicId === row.TransformationType && e.TransformationCapabilitiesType === "TransformationOptions") as TransformationOptionsDto ?? null;
    },

    GetOptionsDetailsForDataTableTransformation: function (row: DataTableFieldMappingDto, transformationsCapabilities: TransformationCapabilitiesDto[]): TransformationOptionsDto | null {

        if (row.TransformationType === null) {
            return null;
        }

        return transformationsCapabilities.find((e) => e.LogicId === row.TransformationType && e.TransformationCapabilitiesType === "TransformationOptions") as TransformationOptionsDto ?? null;
    },

    GetOptionsDetailsForDataTableAggregation: function (row: DataTableFieldMappingDto, transformationsCapabilities: TransformationCapabilitiesDto[]): TransformationOptionsDto | null {

        if (row.AggregationType === null) {
            return null;
        }

        return transformationsCapabilities.find((e) => e.LogicId === row.AggregationType && e.TransformationCapabilitiesType === "TransformationOptions") as TransformationOptionsDto ?? null;
    },

    GetOptionsDetailsForMetaApi: function (row: MetaApiFieldMappingDto, transformationsCapabilities: TransformationCapabilitiesDto[]): TransformationOptionsDto | null {

        if (row.TransformationType === null) {
            return null;
        }

        return transformationsCapabilities.find((e) => e.LogicId === row.TransformationType && e.TransformationCapabilitiesType === "TransformationOptions") as TransformationOptionsDto ?? null;
    },

    GetOptionsDetailsForAI: function (row: AIFieldMappingDto, transformationsCapabilities: TransformationCapabilitiesDto[]): TransformationOptionsDto | null {

        if (row.TransformationType === null) {
            return null;
        }

        return transformationsCapabilities.find((e) => e.LogicId === row.TransformationType && e.TransformationCapabilitiesType === "TransformationOptions") as TransformationOptionsDto ?? null;
    },

    GetConstantDetails: function (row: { TransformationType: number | null }, transformationsCapabilities: TransformationCapabilitiesDto[]): number | null {

        if (row.TransformationType === null || row.TransformationType === undefined) {
            return null;
        }

        return transformationsCapabilities.find((e) => (e.LogicId === 1001 || e.LogicId === 1002 || e.LogicId === 1003) && e.LogicId === row.TransformationType)?.TargetDataType.Type ?? null;
    }
}